var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('HeaderMenu',{staticClass:"center"}),_c('main',[_c('router-view')],1),_c('BackToTopButton'),_c('FooterSite',{staticClass:"center"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }